import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { head } from '@/router/Head';

export const Route = createFileRoute('/_authenticated/_dashboard/accounts/$accountId/settings')({
  staticData: {
    title: 'Settings',
  },
  head,
  component: lazyRouteComponent(() => import('./settings.component'), 'SettingsComponent'),
});
